import { TenantSubscription } from '../../entities/tenant';
import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName, SecurityRight } from '../security.module';

export enum ConfigurationSecurityRight {
    CanAccess = 100000,
    AccessPricing = 100001,
    ManagePricing = 100002,
    AccessMetadata = 100003,
    ManageMetadata = 100004,
    AccessTemplates = 100005,
    ManageTemplates = 100006,
    AccessTenancy = 100007,
    ManageTenancy = 100008,
    AccessCustomFields = 100009,
    ManageCustomFields = 100010,
    AccessJobTemplates = 100011,
    ManageJobTemplates = 100012,
    AccessDocumentThemes = 100013,
    ManageDocumentThemes = 100014,
    AccessBulkImport = 100015,
    // ManageBulkImport = 100016,
    AccessEntityForms = 100020,
    AccessForms = 100021,
    ManageForms = 100022,
}

export const ConfigurationSecurityRightAll = Object.keys(ConfigurationSecurityRight).map(x => ConfigurationSecurityRight[x] as number);

export enum ConfigurationSubModule {
    Pricing = 'Pricing',
    Metadata = 'Metadata',
    Templates = 'Templates',
    Tenancy = 'Tenancy',
    WorkCompliance = 'WorkCompliance',
    IndividualCompliance = 'IndividualCompliance',
    Security = 'Security',
    User = 'User'
}


export class ConfigurationSecurityModule extends BaseSecurityModule<ConfigurationSecurityRight> {

    constructor() {
        super(
            SecurityModuleName.Configuration,
            [
                // { _id: ConfigurationSecurityRight.CanAccess, name: 'Access', basic: true },
                { _id: ConfigurationSecurityRight.AccessPricing, name: 'Access Pricing (Items, Categories, Pricelists)', basic: true },
                { _id: ConfigurationSecurityRight.ManagePricing, name: 'Manage Pricing (Items, Categories, Pricelists)', basic: false },
                { _id: ConfigurationSecurityRight.AccessMetadata, name: 'Access Metadata (Types, Priority, Zones, Statuses, Timesheet Segments)', basic: true },
                { _id: ConfigurationSecurityRight.ManageMetadata, name: 'Manage Metadata (Types, Priority, Zones, Statuses, Timesheet Segments)', basic: false },
                { _id: ConfigurationSecurityRight.AccessTemplates, name: 'Access Templates', basic: true },
                { _id: ConfigurationSecurityRight.ManageTemplates, name: 'Manage Templates', basic: false },
                { _id: ConfigurationSecurityRight.AccessCustomFields, name: 'Access Custom Fields', basic: true },
                { _id: ConfigurationSecurityRight.ManageCustomFields, name: 'Manage Custom Fields', basic: false },

                // { _id: ConfigurationSecurityRight.AccessJobTemplates, name: 'Access Job Templates', basic: true, subscription: TenantSubscription.Professional },
                // { _id: ConfigurationSecurityRight.ManageJobTemplates, name: 'Manage Job Templates', basic: false, subscription: TenantSubscription.Professional },

                { _id: ConfigurationSecurityRight.AccessTenancy, name: 'Access Tenancy (Companies, Tax Tables, Public Holidays, General Settings)', basic: true },
                { _id: ConfigurationSecurityRight.ManageTenancy, name: 'Manage Tenancy (Companies, Tax Tables, Public Holidays, General Settings)', basic: false },
                // { _id: ConfigurationSecurityRight.AccessSecurityRole, name: 'Access Security Role', basic: false },
                // { _id: ConfigurationSecurityRight.ManageSecurityRole, name: 'Manage Security Role', basic: false },
                // { _id: ConfigurationSecurityRight.AccessUser, name: 'Access Users', basic: false },
                // { _id: ConfigurationSecurityRight.ManageUser, name: 'Manage Users', basic: false },

                { _id: ConfigurationSecurityRight.AccessDocumentThemes, name: 'Access Document Themes', basic: true },
                { _id: ConfigurationSecurityRight.ManageDocumentThemes, name: 'Manage Document Themes', basic: false },
                { _id: ConfigurationSecurityRight.AccessBulkImport, name: 'Access Bulk Import', basic: true },

                { _id: ConfigurationSecurityRight.AccessEntityForms, name: 'Access Entity Forms', basic: true },
                // { _id: ConfigurationSecurityRight.AccessForms, name: 'Access Forms', basic: true, subscription: TenantSubscription.Professional },
                // { _id: ConfigurationSecurityRight.ManageForms, name: 'Manage Forms', basic: false, subscription: TenantSubscription.Professional },

            ] as SecurityRight<ConfigurationSecurityRight>[]
        );

        this.plan = TenantSubscription.System;
    }
}
